import parseNumber from '../utils/parseNumber';

export const getTotalUsersByTenant = records =>
  records.map(record => ({
    ...record,
    all_internal_users: parseNumber(record.all_internal_users),
    all_external_users: parseNumber(record.all_users),
    all_users:
      parseNumber(record.all_users) + parseNumber(record.all_internal_users)
  }));
